// src/errorReporting.js
import Raven from 'raven-js';

function configSentry() {
  return Raven.config(process.env.REACT_APP_ERROR_REPORTING_KEY, {
    environment: process.env.NODE_ENV,
  }).install();
}
export default configSentry();



// WEBPACK FOOTER //
// ./src/errorReporting.js